import { TFunction } from "i18next";
import { ProgramRevision } from "../types";

export enum ControlType {
  validateActivities = "validateActivities",
  validateMistakes = "validateMistakes",
  validateEmployees = "validateEmployees",
  validateEmployees2 = "validateEmployees2",
  validateThermometer = "validateThermometer",
  validateProduction = "validateProduction",
  validateCleaning = "validateCleaning",
  validateCleaning2 = "validateCleaning2",
  validatePests = "validatePests",
  validateMaintenance = "validateMaintenance",
}

type ExtendedTFunction = TFunction<"ns1", undefined>;

export const REVISION_CONTROLS = (
  t: ExtendedTFunction,
  defaultValue?: ProgramRevision,
) => [
  {
    title: t("food.SelfMonitoring"),
    type: ControlType.validateActivities,
    value: defaultValue?.validateActivities ?? 1,
  },
  {
    title: t("food.Review"),
    type: ControlType.validateMistakes,
    value: defaultValue?.validateMistakes ?? 1,
  },
  {
    title: t("food.Hygiene"),
    type: ControlType.validateEmployees,
    value: defaultValue?.validateEmployees ?? 1,
  },
  {
    title: t("food.EmployeeSelfMonitoring"),
    type: ControlType.validateEmployees2,
    value: defaultValue?.validateEmployees2 ?? 1,
  },
  {
    title: t("food.Thermometer Check"),
    type: ControlType.validateThermometer,
    value: defaultValue?.validateThermometer ?? 1,
  },
  {
    title: t("food.Production Same"),
    type: ControlType.validateProduction,
    value: defaultValue?.validateProduction ?? 1,
  },
  {
    title: t("food.Cleaning Sufficient"),
    type: ControlType.validateCleaning,
    value: defaultValue?.validateCleaning ?? 1,
  },
  {
    title: t("food.Cleaning Procedures"),
    type: ControlType.validateCleaning2,
    value: defaultValue?.validateCleaning2 ?? 1,
  },
  {
    title: t("food.Pest Protection"),
    type: ControlType.validatePests,
    value: defaultValue?.validatePests ?? 1,
  },
  {
    title: t("food.Maintenance Followed"),
    type: ControlType.validateMaintenance,
    value: defaultValue?.validateMaintenance ?? 1,
  },
];
